import { SettingsMap } from "web/components/Map/index"

export default function StaticMap({ locations, lngLatFn, onLocationClick }) {
  return (
    <div className="h-full w-full rounded">
      <SettingsMap
        locations={locations}
        lngLatFn={lngLatFn}
        isStatic={true}
        onLocationClick={onLocationClick}
      />
    </div>
  )
}
